import React from "react";
import {connect} from "react-redux";
import {State} from "../reducers";
import {Icon} from "@vitalsource/vstui";
import {Button} from "@vitalsource/vstui";
import ProductProgressIndicator from "../components/progressIndicator/ProductProgressIndicator";
import {ProductDataItem} from "../types/StudioAPITypes";

export interface OwnProps {
  children: React.ReactNode;
  id: string;
}

const derivePropertyInfo = (type: string, status: string, progress?: number) => {
  return {
    actionType: type,
    status: status,
    progress: progress
  }
}

const getProgressInfo = (productId: string, productStatus: string, progressPct: number | undefined) => {
  const PRODUCT_STATUS = {
    ACTIVE: "Active",
    DUPLICATION_IN_PROGRESS: "Duplication In Progress",
    CONVERSION_IN_PROGRESS: "Conversion In Progress",
    CONVERSION_FAILED: "Conversion Failed"
  };

  switch (productStatus) {
   case PRODUCT_STATUS.CONVERSION_FAILED:
     return derivePropertyInfo("CONVERSION", "FAILURE", 100);
    case PRODUCT_STATUS.CONVERSION_IN_PROGRESS:
      return derivePropertyInfo("CONVERSION","IN_PROGRESS", progressPct, );
   /*
   * TODO uncomment this when implementing duplication indicator
   case PRODUCT_STATUS.DUPLICATION_IN_PROGRESS:
      return derivePropertyInfo("DUPLICATION", 100, "IN_PROGRESS");
      */
    case PRODUCT_STATUS.ACTIVE:
      return derivePropertyInfo("", "SUCCESS", 100);
    default:
      return derivePropertyInfo("", "", 0);
  }
}

const mapStateToProps = (state: State, ownProps: OwnProps) => {
  let item = state.products.items.find((product: any) => {
    return ownProps.id === product.id;
  }) as ProductDataItem;

  let progressInfo = getProgressInfo(item.id, item.status, item.progressPct);
    return {
      actionType: progressInfo.actionType,
      status: progressInfo.status,
      progress: progressInfo.progress
    }
};

export default connect(mapStateToProps)(ProductProgressIndicator);
